<template>
  <div class="pushchannelmanagetable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;"  border>
      <el-table-column prop="createAtMY" label="创建时间" width="160"></el-table-column>
      
      <el-table-column label="邀约类型 " width="220">
        <template slot-scope="scope">
          <div>
            <p v-if="scope.row.appointUids === '0'">公开需求</p>
            <p :style="{'color': isSimple ? '#E27B02' : '#194897'}" v-if="scope.row.appointUids !== '0'">定向需求(指定{{scope.row.appointUids.split(',').length}}人)</p>
            
          </div>
        </template>
      </el-table-column>

      <el-table-column label="标题">
        <template slot-scope="scope">
          <span class="tit" @click="openDialog(scope.row)" style="color: #5b9bd1;cursor: pointer;">{{scope.row.title}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="status" label="状态" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">
            <el-tag type="success">{{'开启'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 0">
            <el-tag type="danger">{{'停用'}}</el-tag>
          </div>

          <div v-if="scope.row.status !== 0 && scope.row.status !== 1">
            <el-tag type="info">{{'无'}}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column v-if="false" label="已收集图片">
        <template slot-scope="scope">
          <div style="display:flex;">
            <p style="margin-right:10px;" v-if="seepswIndex.indexOf(scope.$index) === -1">{{scope.row.zhang}}张/{{scope.row.ren}}人投稿</p>
            <p style="margin-right:10px;" v-if="seepswIndex.indexOf(scope.$index) !== -1">***张/***人投稿</p>
            
            <div @click="seePsw(scope.$index)" :class="seepswIndex.indexOf(scope.$index) !== -1 ?'hidpsw':'seepsw'"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="400">
        <template slot-scope="scope">
          <div>
            <el-button @click="changeClick(scope)" type="text" style="color:#185ED3;font-weight:bold;font-size:13px;" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-edit-outline"></i>修改</el-button>
            <span style="margin:0 11px;"> | </span>
            <el-button @click="closeClick(scope)" v-if="scope.row.status === 1" style="color:#F96900;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-circle-close"></i>关闭</el-button>
            <el-button @click="closeClick(scope)" v-if="scope.row.status !== 1" style="color:#13aa65;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-document-checked"></i>开启</el-button>
            <span style="margin:0 11px;"> | </span>
            <el-button @click="seePic(scope)" type="text" style="color:#3086F0;font-weight:bold;font-size:13px;" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-picture-outline"></i>查看图片</el-button>
            <span style="margin:0 11px;"> | </span>
            <el-button @click="delectClick(scope)" type="text" style="color:#FF4545;font-weight:bold;font-size:13px;" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-delete"></i>删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        :visible.sync="detailDialogVisible"
        width="70%"
        :before-close="handleClosedetail">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>图片邀约详情</div>
      </div>
      <div>
        <div style="text-align:center;font-size:15px;font-weight:600;margin-bottom:15px;">{{this.picMsg.title}}</div>
        <div style="display:flex;justify-content: space-around;">
          <div>发起人：{{this.picMsg.userName}}</div>
          <div>创建时间：{{this.picMsg.createAtMY}}</div>
        </div>
        <div style="width:80%;text-align:center;font-size:15px;font-weight:600;margin:25px auto;border-top:1px solid #cccccc;"></div>
        <div style="width:75%;margin:10px auto;">
          <div v-html="this.picMsg.content" style="height:420px;overflow-y: auto;box-sizing: border-box;padding:20px;box"></div>
        </div>

        <!-- <div>创建时间：{{this.picMsg.createAtMY}}</div>
        <br>
        <div>标题：<span v-html="this.picMsg.content"></span></div> -->
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getUser } from "@/api/user";
import { powersObj } from "@/constants/powers";
export default {
  name: "pushchannelmanagetable",
  props: {
    tableData:Array,
  },
  computed:{
    ...mapGetters(["powers"])
  },
  data() {
    return {
      //权限
      powersObj,


      detailDialogVisible:false,
      picMsg:{},
      seepswFlag: false,
      seepswIndex: [],
      // tableData: [
        // {
        //   date: "2020-04-21",
        //   type: "公开需求",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // }
      // ]
    };
  },
  methods: {
    handleClosedetail(){
      this.detailDialogVisible = false
    },
    openDialog(item){
      this.picMsg = item
      this.getUserAsync(this.picMsg.createUid)  
    },

    closeClick(scope) {
      this.$emit("authClick", scope);
    },
    changeClick(scope) {
      this.$emit("changeClick", scope);
    },
    seePic(scope) {
      this.$emit("seePic", scope);
    },
    delectClick(scope) {
      this.$emit("delectClick", scope);
    },
    linkClick(scope) {
      // this.$emit('removeClick',scope)
      this.mydialogVisible = true;
    },
    quit() {
      this.mydialogVisible = false;
    },
    handleClose() {
      this.mydialogVisible = false;
    },
    seePsw(index){
      // console.log(index)
      
      // this.seepswFlag = !this.seepswFlag
      if(this.seepswIndex.indexOf(index) === -1){
        this.seepswIndex.push(index)
      }else{
        this.seepswIndex.splice(this.seepswIndex.indexOf(index),1)
      }
      // console.log(this.seepswIndex)
    },



    //查询用户
    async getUserAsync(val) {
      let { status, data, message } = await getUser(val);
      if (status) {
        this.picMsg.userName = data.name
        this.detailDialogVisible = true
      } else {
        this.picMsg.userName = '用户一'
        this.detailDialogVisible = true
      }
    },
  },
  created() {

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.table {
  width: auto;
}
.seepsw {
  width: 18px;
  height: 18px;
  cursor: pointer;
  background: url("~@/assets/house/nohidpsw.png") no-repeat;
}
.seepsw:hover {
  background: url("~@/assets/house/nohidpswh.png") no-repeat;
}
.hidpsw {
  width: 18px;
  height: 18px;
  cursor: pointer;
  background: url("~@/assets/house/hidpsw.png") no-repeat;
}
.hidpsw:hover {
  background: url("~@/assets/house/hidpswh.png") no-repeat;
}
.el-table /deep/ .cell .tit:hover{
  text-decoration: underline !important;
}
.btn:hover{
  text-decoration: underline;
}
</style>
